import React from 'react'

import {Container } from 'semantic-ui-react'

import PlayerForm from './pregame/playerForm'

import './style.scss'

import Header from 'components/header'
import { useNavigate } from 'react-router-dom'

const TourCore = () => {
    const navigate = useNavigate();
    return(
        <div className='melee-wrapper'>
          <Container className='regularText' style={{ paddingTop: 10, paddingBottom: 10 }}>
          <Header 
            helmet='Create Tournament'
            rightMenu={
            <button 
              className="melee-inline-button"
              onClick={() => navigate(-1)}
            >
              Back
          </button>}
          />
          <div style={{margin: '2em 0px'}}>
            <PlayerForm/>
          </div>
          
          </Container>
        </div>
    )
}

export default TourCore;